import { useIntl } from 'react-intl';
import { Card } from './index';
import { ActivityCardEnum } from './ActivitiesCardConstants';
import { DealActivityList } from '../activities';

type ActivityCardProps = {
  dealData: { [key: string]: any };
  dealDocumentsData?: { [key: string]: any };
  isSidebar?: boolean;
};

const ActivitiesCard = ({ dealData, dealDocumentsData: _dealDocumentsData, isSidebar }: ActivityCardProps) => {
  const { formatMessage } = useIntl();
  const dealId = dealData?.id;

  if (!dealId) {
    return (
      <Card
        title={
          !isSidebar && formatMessage({ id: ActivityCardEnum.ID, defaultMessage: ActivityCardEnum.DEFAULT_MESSAGE })
        }
        isBlue={!isSidebar}
        isSidebar={isSidebar}
        isActivitiesCard
        isFullHeight
        width={'4'}
        className={!isSidebar ? 'mr-3 ml-1 non-mobile' : 'mobile'}
      >
        <div className="text-center p-4">Loading activities...</div>
      </Card>
    );
  }

  return (
    <Card
      title={!isSidebar && formatMessage({ id: ActivityCardEnum.ID, defaultMessage: ActivityCardEnum.DEFAULT_MESSAGE })}
      isBlue={!isSidebar}
      isSidebar={isSidebar}
      isActivitiesCard
      isFullHeight
      width={'4'}
      className={!isSidebar ? 'mr-3 ml-1 non-mobile' : 'mobile'}
    >
      <DealActivityList dealId={dealId} isSidebar={isSidebar} />
    </Card>
  );
};

export default ActivitiesCard;
